import { useRouter } from "next/router";
import React from "react";
import { useRecoilValue } from "recoil";
import { TestDriveBannerAtom } from "../atoms/TestDriveBannerAtom";
import { UserAtom } from "../atoms/UserAtom";
import TestDriveBanner from "../components/TestDriveBanner/TestDriveBanner";

export default function Main(props: { ComponentContent: JSX.Element }) {
  const { ComponentContent } = props;
  const router = useRouter();
  const showTestDrive = useRecoilValue(TestDriveBannerAtom);
  const user = useRecoilValue(UserAtom);

  const ROUTES_WITHOUT_TESTDRIVE = [
    "/contacts/import-emails",
    "/create-campaign",
    "/form-builder",
    "/backup",
    "/confirmed",
    "/form-builder-preview",
    "/internal-form",
    "/login",
    "/account-selection",
    "/signup",
    "/reset-passcode",
    "/thank-you",
    "/unsubscribe",
    "/",
    "/complete-onboarding",
    "/getting-started",
    "/thank-you-purchase",
  ];

  function getBanner() {
    if (ROUTES_WITHOUT_TESTDRIVE.includes(router.asPath.split("?")[0])) return;
    if (!user) return;
    if (showTestDrive.show)
      return <TestDriveBanner endTime={showTestDrive.testDriveExpiration} />;
    // if (!user?.domainIsVerified) return <VerifyDomainBanner />;
  }

  return (
    <>
      {getBanner()}
      {ComponentContent}
    </>
  );
}
